import React from 'react';
import NotFound from 'ui/not-found';

const NotFoundTastic = () => {
  return <NotFound />;
};

export default NotFoundTastic;
